import { sendGet, sendPost } from '../hooks/use-fetch'
import { type SaveSurveyResultRequest } from '../models/requestObjects/SurveyRequestObjects'
import { type SurveySchema } from '../models/SurveySchema'

export async function GetSurvey (schemaId: number, annualPlanId: number): Promise<SurveySchema> {
  const { response } = await sendGet(`Survey/Schema/${schemaId}?annualPlanId=${annualPlanId}`)
  return response
}

export async function SaveSurveyResults (surveyResult: SaveSurveyResultRequest): Promise<void> {
  await sendPost('Survey/SaveResults', surveyResult)
}
